/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculateCancellationPenaltyResponseDto
 */
export interface CalculateCancellationPenaltyResponseDto {
    /**
     * Property ID
     * @type {string}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    propertyId: string;
    /**
     * RoomType ID
     * @type {string}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    roomTypeId: string;
    /**
     * Name
     * @type {string}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    name: string;
    /**
     * arrivalDateTime
     * @type {string}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    arrivalDateTime: string;
    /**
     * departureDateTime
     * @type {string}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    departureDateTime: string;
    /**
     * Количество взрослых
     * @type {number}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    adults: number;
    /**
     * Штраф при отмене бронирования
     * @type {number}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    penalty: number;
    /**
     * Предоплата, которая была взята за бронирование
     * @type {number}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    prepayment: number;
    /**
     * ID тарифного плана
     * @type {string}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    ratePlanId: string;
    /**
     * Количество детей
     * @type {Array<number>}
     * @memberof CalculateCancellationPenaltyResponseDto
     */
    children: Array<number>;
}

/**
 * Check if a given object implements the CalculateCancellationPenaltyResponseDto interface.
 */
export function instanceOfCalculateCancellationPenaltyResponseDto(value: object): value is CalculateCancellationPenaltyResponseDto {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('roomTypeId' in value) || value['roomTypeId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('arrivalDateTime' in value) || value['arrivalDateTime'] === undefined) return false;
    if (!('departureDateTime' in value) || value['departureDateTime'] === undefined) return false;
    if (!('adults' in value) || value['adults'] === undefined) return false;
    if (!('penalty' in value) || value['penalty'] === undefined) return false;
    if (!('prepayment' in value) || value['prepayment'] === undefined) return false;
    if (!('ratePlanId' in value) || value['ratePlanId'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    return true;
}

export function CalculateCancellationPenaltyResponseDtoFromJSON(json: any): CalculateCancellationPenaltyResponseDto {
    return CalculateCancellationPenaltyResponseDtoFromJSONTyped(json, false);
}

export function CalculateCancellationPenaltyResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateCancellationPenaltyResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'roomTypeId': json['roomTypeId'],
        'name': json['name'],
        'arrivalDateTime': json['arrivalDateTime'],
        'departureDateTime': json['departureDateTime'],
        'adults': json['adults'],
        'penalty': json['penalty'],
        'prepayment': json['prepayment'],
        'ratePlanId': json['ratePlanId'],
        'children': json['children'],
    };
}

  export function CalculateCancellationPenaltyResponseDtoToJSON(json: any): CalculateCancellationPenaltyResponseDto {
      return CalculateCancellationPenaltyResponseDtoToJSONTyped(json, false);
  }

  export function CalculateCancellationPenaltyResponseDtoToJSONTyped(value?: CalculateCancellationPenaltyResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'roomTypeId': value['roomTypeId'],
        'name': value['name'],
        'arrivalDateTime': value['arrivalDateTime'],
        'departureDateTime': value['departureDateTime'],
        'adults': value['adults'],
        'penalty': value['penalty'],
        'prepayment': value['prepayment'],
        'ratePlanId': value['ratePlanId'],
        'children': value['children'],
    };
}

